// extracted by mini-css-extract-plugin
export var author = "search-field-module--author--e83c8";
export var category = "search-field-module--category--3854d";
export var headline = "search-field-module--headline--92ba9";
export var headlinePost = "search-field-module--headline-post--14b51";
export var paragraph = "search-field-module--paragraph--c2a9c";
export var searchField = "search-field-module--search-field--5b9fd";
export var searchInput = "search-field-module--search-input--33193";